enum TextSectionsLengths {
  'name' = 100,
  'tiny' = 200,
  'short' = 2000,
  'medium' = 10000,
  'long' = 50000,
}

export default TextSectionsLengths
